module.exports = __webpack_public_path__ + "aaa4578a373bfb6e611f0d446de6259f.png";